import { utils } from 'ethers'

import IStakingRewardsABI from '../../abi/IStakingRewards.abi.json'
import IMegaPoolABI from '../../abi/IMegaPool.abi.json'

export const stakingRewardsInterface = new utils.Interface(IStakingRewardsABI)
export const megaPoolInterface = new utils.Interface(IMegaPoolABI)
